import { combineReducers } from "redux";

import { login, registration } from "../user/Reducer";
import { alert } from "../alert/Reducer";
import { measurementList } from "../measurements/Reducer";
import { measurements } from "../bootstrap/Reducer";

const rootReducer = combineReducers({
  login,
  registration,
  alert,
  measurementList,
  measurements
});

export default rootReducer;
